export default "https://studio-ui-deployments.apollographql.com/build/static/assets/favicon-local.054997f3be56790d7ffda5ee6419a27d.png";